import { EHttpMethods } from "../../../../enums";
import { WITHDRAWS_BASE_URL } from "./constants";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { getToken } from "../../../context/authContext";
import {
  IWithdrawalDetailsResponse,
  IWithdrawalExecutionResponse,
  IWithdrawalResponse,
  ExecuteWithdrawBody,
} from "./models";
import { WITHDRAW_STATUS } from "../../../../pages/withdraws/constants";

const defaultProvide = async () => await getToken();

export const getWithdraws = (body: {
  beneficiaryId?: string;
  domainId?: string;
  statuses: WITHDRAW_STATUS[];
  page: number;
  size: number;
}): Promise<IWithdrawalResponse> => {
  let url = `${WITHDRAWS_BASE_URL}?statuses=${body?.statuses || []}&page=${
    body?.page || 0
  }&size=${body?.size || 10}`;

  if (body?.beneficiaryId) {
    url += `&beneficiaryId=${body.beneficiaryId}`;
  }

  if (body?.domainId) {
    url += `&domainId=${body.domainId}`;
  }

  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getWithdrawDetails = ({
  id,
  page = 0,
  size = 10,
}: {
  id: string;
  page?: number;
  size?: number;
}): Promise<IWithdrawalDetailsResponse> => {
  const url = `${WITHDRAWS_BASE_URL}/${id}/details?page=${page}&size=${size}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const executeWithdraw = (
  id: string,
  manualWithdrawBody?: ExecuteWithdrawBody
): Promise<IWithdrawalExecutionResponse> => {
  const url = `${WITHDRAWS_BASE_URL}/${id}/execute`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, manualWithdrawBody);
};

export const executeWithdrawV2 = (
  id: string,
  manualWithdrawBody?: ExecuteWithdrawBody
): Promise<IWithdrawalExecutionResponse> => {
  const url = `${WITHDRAWS_BASE_URL}/v2/${id}/execute`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, manualWithdrawBody);
};
